module.exports = __webpack_public_path__ + "img/new_template.f50a4e5c.png";